<form [formGroup]="form" class="form container">

  <!-- <div *ngFor="let group of groups" formGroupName="{{group}}"> -->
  @for (field of formFields; track trackByFieldName($index, field)) {
    <ng-container formGroupName="{{field.group}}">
      <!-- <ng-container *ngIf="field.group === group"> -->
      @if (field.type === 'heading') {
        <h3>{{field.label}}</h3>
        <hr />
      } @else {
        @if (isVisible(field)) {
          <div class="lg:col-span-6 offset-lg-3 mb-4">
            @if (field.type !== 'checkbox') {
              <label for="{{field.name}}" class="form-label">{{field.label}}@if (field.required) {
                <span class="text-error pl-2">*</span>
              }</label>
            }
            @if (field.type === 'text') {
              <input pInputText autocomplete="off" placeholder="{{field.placeholder}}" id="{{field.name}}" type="text"
                class="form-control " formControlName="{{field.name}}"
                attr.aria-describedby="{{field.name}}-validation">
            }
            @if (field.type === 'number') {
              <p-inputNumber placeholder="{{field.placeholder}}" id="{{field.name}}" type="number" [allowEmpty]="false"
                class="form-control " formControlName="{{field.name}}" [useGrouping]="field?.typeOptions?.numberSeparator === undefined ? true : field.typeOptions?.numberSeparator"
              attr.aria-describedby="{{field.name}}-validation"></p-inputNumber>
            }
            @if (field.type === 'textarea') {
              <textarea pTextarea id="{{field.name}}" formControlName={{field.name}}
                placeholder="{{field.placeholder}}" class="form-control"
              attr.aria-describedby="{{field.name}}-validation" rows="3"></textarea>
            }
            @if (field.type === 'yesno') {
              <p-select appendTo="body" [options]="[{label: 'Select...', value: ''},{label: 'Yes', value: '1'}, {label: 'No', value:'0' }]" id="{{field.name}}"
                formControlName={{field.name}} class="form-control"
              attr.aria-describedby="{{field.name}}-validation">></p-select>
            }
            @if (field.type === 'date') {
              <p-datepicker fluid appendTo="body" class="block w-full" placeholder="m/d/yyyy" [showIcon]="true" hourFormat="12" [id]="field.name" formControlName="{{field.name}}"></p-datepicker>
            }
            @if (field.type === 'dob') {
              <app-birthday-picker class="block" [id]="field.name" appendTo="body"  [formControlName]="field.name"></app-birthday-picker>
            }
            @if (field.type === 'datetime') {
              <p-datepicker fluid [showTime]="true" hourFormat="12" appendTo="body" class="block w-full"
                [showIcon]="true" [id]="field.name" formControlName="{{field.name}}"
                [hideOnDateTimeSelect]="false">
              </p-datepicker>
            }
            @if (field.type === 'dropdown') {
              <p-select appendTo="body" id="{{field.name}}" formControlName={{field.name}} [options]="field.options ?? []"  class="form-control"
              attr.aria-describedby="{{field.name}}-validation"></p-select>
            }
            @if (field.type === 'checkbox') {
              <div class="form-check">
                <div class="flex gap-2">
                  <p-checkbox [inputId]="field.name" [binary]="true" formControlName="{{field.name}}" [attr.aria-describedby]="field.name + '-valudation'"></p-checkbox>
                  <!-- <input id="{{field.name}}" type="checkbox" formControlName="{{field.name}}" class="form-check-input"
                  attr.aria-describedby="{{field.name}}-validation"> -->
                  <label [for]="field.name" class="form-check-label">{{field.label}}</label>
                </div>
              </div>
            }
            <!-- checking touched here causes dropdowns/calendar to not select properly on the first click -->
            @if (getControl(field)?.invalid && (getControl(field)?.dirty)) {
              <div
                id="{{field.name}}-validation" class="invalid-feedback">
                @if (getControl(field)?.errors?.['required']) {
                  <div>
                    {{field.label}} is required
                  </div>
                }
              </div>
            }
          </div>
        }
      }
    <!-- </ng-container> -->
  </ng-container>
}
<!-- </div> -->
@if(form.invalid && submitted) {
  <p-message severity="error" styleClass="mb-4">

    @for (field of formFields; track field.name) {
      @if(getControl(field)?.invalid && getControl(field)?.errors?.['required']) {
        <div>"{{field.label}}" is required</div>
      }
    }

  </p-message>
}

<button pButton type="button" class="offset-lg-8" (click)="onSubmit()" [disabled]="disableSubmit"
useSubmitBehavior="false" label="Submit"></button>

</form>
